import { observer } from 'mobx-react'
import React, { Component } from 'react'

import UniqueUsersStore from './UniqueUsersStore'
import Panel from '../../../../UniformComponents/Panel'
import Date from '../../../form/Date'
import DataTable from '../../../DataTable'
import Button from '../../../../UniformComponents/Button'

import './uniqueUsers.scss'

@observer
class SystemUniqueUsers extends Component {
    constructor(props) {
        super(props)
        const { store } = props
        this.uniqueUsersStore = new UniqueUsersStore(store)
    }

    componentDidMount() {
        const { store } = this.props
        store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'systemUniqueUsers',
                url: '/intranet/systemUniqueUsers',
                title: 'System Unique Users',
            },
        ]
    }

    renderFilters = () => {
        const { request, handleChangeRequest, getUniqueUsers } = this.uniqueUsersStore
        const { startDate, endDate } = request
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div>
                    <Date
                        label="Start Date"
                        onBlur={(value) => handleChangeRequest(value, 'start')}
                        placeholder={startDate || 'YYYY-MM-DD'}
                        dateFormat="YYYY-MM-DD"
                        allowManualDateEdit
                    />
                </div>

                <div>
                    <Date
                        label="End Date"
                        onBlur={(value) => handleChangeRequest(value, 'end')}
                        placeholder={endDate || 'YYYY-MM-DD'}
                        dateFormat="YYYY-MM-DD"
                        allowManualDateEdit
                    />
                </div>

                <Button
                    label="GO"
                    cssClass="regular primary"
                    onClick={() => getUniqueUsers()}
                />
            </div>
        )
    }

    renderDataTable = () => {
        const { data, columns } = this.uniqueUsersStore
        return (
            <DataTable
                store={{ filteredList: data }}
                dataSet={data}
                columns={columns}
            />
        )
    }

    render() {
        const { isResultFetched } = this.uniqueUsersStore
        return (
            <Panel id="uniqueUsers">
                {isResultFetched
                    ? (
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 20 }}>
                            <div style={{ width: '25%' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    {this.renderFilters()}
                                </div>
                            </div>
                            <div style={{ width: '75%' }}>
                                <div>
                                    <Panel style={{ overflow: 'auto' }}>
                                        {this.renderDataTable()}
                                    </Panel>
                                </div>
                            </div>
                        </div>
                    )
                    : (
                        <div>
                            <div className="initialCol">
                                {this.renderFilters()}
                            </div>
                        </div>
                    )}
            </Panel>
        )
    }
}
export default SystemUniqueUsers
